import React, { Component } from 'react';

import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';

import configs from '../../../configs/environments';

interface PickupOrderDriverContainerProps {
  google: any;
  userLocation: { lat: number, lng: number };
  destination: { lat: number, lng: number };
};

interface PickupOrderDriverContainerState {
  destinationMarkerSVGPath: any;
  positionMarkerSVGPath: any;
};

class DriverETAMap extends Component<PickupOrderDriverContainerProps, PickupOrderDriverContainerState> {
  
  state = {
    destinationMarkerSVGPath: undefined,
    positionMarkerSVGPath: undefined
  };

  componentDidMount() {

    this.setState({
      positionMarkerSVGPath: {
        path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
        fillColor: '#ff0000', //color of the marker
        fillOpacity: 1,
        strokeWeight: 0,
        scale: 2, //size of the marker, careful! this scale also affects anchor and labelOrigin
        anchor: new this.props.google.maps.Point(13, 23), //position of the icon, careful! this is affected by scale
        labelOrigin: new this.props.google.maps.Point(205, 190) //position of the label, careful! this is affected by scale
      }, destinationMarkerSVGPath: {
        path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
        fillColor: '#222222', //color of the marker
        fillOpacity: 1,
        strokeWeight: 0,
        scale: 2, //size of the marker, careful! this scale also affects anchor and labelOrigin
        anchor: new this.props.google.maps.Point(13, 23), //position of the icon, careful! this is affected by scale
        labelOrigin: new this.props.google.maps.Point(205, 190) //position of the label, careful! this is affected by scale
      }
    })
  }

  render() {
    return (
      <div>
        <Map google={ this.props.google } zoom={ 3 } initialCenter={ this.props.userLocation } >
          <Marker
            icon={ this.state.destinationMarkerSVGPath }
            title={ "Destination"}
            position={ this.props.destination } />
          <Marker
            icon={ this.state.positionMarkerSVGPath }
            title={ "Current position" }
            position={ this.props.userLocation } />
        </Map>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: (configs.googleMapsApiKey)
})(DriverETAMap)